var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PencilLine",
    clipPath: "url(#clip0_1540_4067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.4375 21.9375H10.25L4.61426 16.3018",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.1562 9.34375L7.40625 19.0938",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.25 21.9374H5.375C5.15951 21.9374 4.95285 21.8518 4.80048 21.6994C4.6481 21.547 4.5625 21.3404 4.5625 21.1249V16.5861C4.5626 16.3709 4.64807 16.1645 4.80016 16.0122L17.3248 3.48754C17.4772 3.33529 17.6838 3.24976 17.8992 3.24976C18.1146 3.24976 18.3212 3.33529 18.4735 3.48754L23.0123 8.02332C23.1646 8.17568 23.2501 8.38226 23.2501 8.59766C23.2501 8.81306 23.1646 9.01964 23.0123 9.172L10.25 21.9374Z",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.3125 6.5L20 12.1875",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1540_4067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencilIcon.7e983cf6318b08ded26bbd0014d98c89.svg";
export { ForwardRef as ReactComponent };